import overlayApi from "solid-overlays";

import ModalSheetLayout from "@repo/ui/overlays/ModalSheetLayout";
import UObject from "@repo/utils/UObject";

import { track } from "~/analytics/client.js";

const overlayByPath = Object.assign(
  UObject.trimKeys(
    // prettier-ignore
    import.meta.glob("./**/*.tsx") as unknown as {
/* GENERATED */ "./CommunityGuidelines.tsx": () => Promise<typeof import("./CommunityGuidelines.tsx")>,
/* GENERATED */ "./ShowScoreDisclaimer.tsx": () => Promise<typeof import("./ShowScoreDisclaimer.tsx")>,
/* GENERATED */ "./admin/AddVotes.tsx": () => Promise<typeof import("./admin/AddVotes.tsx")>,
/* GENERATED */ "./admin/ConfirmBan.tsx": () => Promise<typeof import("./admin/ConfirmBan.tsx")>,
/* GENERATED */ "./admin/ConfirmDeletion.tsx": () => Promise<typeof import("./admin/ConfirmDeletion.tsx")>,
/* GENERATED */ "./admin/CreateProfile.tsx": () => Promise<typeof import("./admin/CreateProfile.tsx")>
},
    "./",
    ".tsx"
  ),
  UObject.trimKeys(
    // prettier-ignore
    import.meta.glob("../**/*.overlay.tsx") as unknown as {

},
    "./",
    ".overlay.tsx"
  )
);

export type OverlayKey = keyof typeof overlayByPath;

export const {
  OverlaysProvider,
  useOverlay,
  useOverlayBackdrop,
  useOverlayLayout,
  useOverlaysBase,
  useOverlaysController,
} = overlayApi(overlayByPath, {
  DefaultLayout: ModalSheetLayout,
}).create({
  hooks: {
    open(key, props) {
      track("overlay: push", { key, props });
    },
  },
});
